








import Vue from 'vue';
import {Component} from "vue-property-decorator";
import OfficeReportsToCheck from "@/components/home/OfficeReportsToCheck.vue";
import OfficeWeeklyOverview from "@/components/home/OfficeWeeklyOverview.vue";
import OfficePendingReports from "@/components/home/OfficePendingReports.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {OfficePendingReports, OfficeWeeklyOverview, OfficeReportsToCheck}
})
export default class HomeOffice extends Vue {

	private get isCheckReports(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCheckReports);
	}

}
